const defaultDayHours = () => ({
  opening_time: '09:00',
  closing_time: '17:00',
  lunch_start: '14:00',
  lunch_end: '15:00',
});

export function normalizeTypeExceptionsFromApi(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((e) => e && typeof e === 'object' && String(e.date || '').trim())
    .map((e, idx) => ({
      id: String(e.id || `exc-${idx}-${String(e.date).slice(0, 10)}`),
      date: String(e.date).trim().slice(0, 10),
      reason: String(e.reason || '').trim(),
      is_closed: e.is_closed !== false,
      all_day: e.all_day !== false && !String(e.closed_start || '').trim(),
      closed_start: e.closed_start ? String(e.closed_start).slice(0, 5) : null,
      closed_end: e.closed_end ? String(e.closed_end).slice(0, 5) : null,
    }));
}

export function normalizeTypeScheduleFromApi(data) {
  const base = {
    opening_time: data?.opening_time || '09:00',
    closing_time: data?.closing_time || '17:00',
    lunch_start: data?.lunch_start || '14:00',
    lunch_end: data?.lunch_end || '15:00',
    working_days: Array.isArray(data?.working_days) ? [...data.working_days] : [1, 2, 3, 4, 5],
    appointment_duration: data?.appointment_duration != null ? Number(data.appointment_duration) : 30,
    urgent_opening_time: data?.urgent_opening_time || '19:30',
    urgent_closing_time: data?.urgent_closing_time || '20:30',
    urgent_appointment_duration:
      data?.urgent_appointment_duration != null ? Number(data.urgent_appointment_duration) : 30,
    per_day: {},
    exceptions: normalizeTypeExceptionsFromApi(data?.exceptions),
  };
  const fallback = () => ({
    opening_time: base.opening_time,
    closing_time: base.closing_time,
    lunch_start: base.lunch_start,
    lunch_end: base.lunch_end,
  });
  for (let d = 1; d <= 7; d++) {
    const k = String(d);
    const incoming = data?.per_day?.[k];
    base.per_day[k] = incoming
      ? {
          opening_time: incoming.opening_time || base.opening_time,
          closing_time: incoming.closing_time || base.closing_time,
          lunch_start: incoming.lunch_start || base.lunch_start,
          lunch_end: incoming.lunch_end || base.lunch_end,
        }
      : fallback();
  }
  return base;
}

export function emptyTypeSchedule() {
  const empty = defaultDayHours();
  return {
    ...empty,
    working_days: [1, 2, 3, 4, 5],
    appointment_duration: 30,
    urgent_opening_time: '19:30',
    urgent_closing_time: '20:30',
    urgent_appointment_duration: 30,
    per_day: Object.fromEntries([1, 2, 3, 4, 5, 6, 7].map((d) => [String(d), { ...empty }])),
    exceptions: [],
  };
}

export function formatTypeExceptionScope(exc) {
  const isAllDay = exc.all_day !== false && !String(exc.closed_start || '').trim();
  if (isAllDay) return 'Todo el día';
  const a = String(exc.closed_start || '').slice(0, 5);
  const b = String(exc.closed_end || '').slice(0, 5);
  if (a && b) return `${a} – ${b}`;
  return 'Horario parcial';
}

export const DAYS_OF_WEEK = [
  { id: 1, name: 'Lunes' },
  { id: 2, name: 'Martes' },
  { id: 3, name: 'Miércoles' },
  { id: 4, name: 'Jueves' },
  { id: 5, name: 'Viernes' },
  { id: 6, name: 'Sábado' },
  { id: 7, name: 'Domingo' },
];
